import { render, staticRenderFns } from "./businessFollower.vue?vue&type=template&id=8bd86fc2&scoped=true"
import script from "./businessFollower.vue?vue&type=script&lang=js"
export * from "./businessFollower.vue?vue&type=script&lang=js"
import style0 from "./businessFollower.vue?vue&type=style&index=0&id=8bd86fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd86fc2",
  null
  
)

export default component.exports